// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/govcon_graph.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.datagateway.v1.EntityNode
 */ export class EntityNode extends Message {
    static fromBinary(bytes, options) {
        return new EntityNode().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EntityNode().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EntityNode().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EntityNode, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * company|gov_org|vehicle|partner
   *
   * @generated from field: string node_type = 3;
   */ _define_property(this, "nodeType", ""), /**
   * @generated from field: string display_name = 4;
   */ _define_property(this, "displayName", ""), /**
   * ryugu CompanyProfile/ContractVehicle id (company|vehicle)
   *
   * @generated from field: string ryugu_ref = 5;
   */ _define_property(this, "ryuguRef", ""), /**
   * JSON object; merge folds aliases here
   *
   * @generated from field: string attributes_json = 6;
   */ _define_property(this, "attributesJson", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 9;
   */ _define_property(this, "deletedAt", void 0), /**
   * REG-57 identity: the registry row the node draws (survivor id; labels are read from
   * it), or the public key of an entity no registry holds yet. Every live node has one.
   *
   * CONTACT | COMPANY | GOVERNMENT_ORG | VEHICLE
   *
   * @generated from field: string registry_kind = 10;
   */ _define_property(this, "registryKind", ""), /**
   * @generated from field: string registry_id = 11;
   */ _define_property(this, "registryId", ""), /**
   * @generated from field: string public_key = 12;
   */ _define_property(this, "publicKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EntityNode, "runtime", proto3);
_define_property(EntityNode, "typeName", "mono.datagateway.v1.EntityNode");
_define_property(EntityNode, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "node_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "ryugu_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "attributes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "registry_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "public_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.EntityEdge
 */ export class EntityEdge extends Message {
    static fromBinary(bytes, options) {
        return new EntityEdge().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EntityEdge().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EntityEdge().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EntityEdge, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string from_node = 3;
   */ _define_property(this, "fromNode", ""), /**
   * @generated from field: string to_node = 4;
   */ _define_property(this, "toNode", ""), /**
   * parent|subsidiary|jv|mentor_protege|vehicle_holder|org_parent|...
   *
   * @generated from field: string edge_type = 5;
   */ _define_property(this, "edgeType", ""), /**
   * public_data|user_intel|sds_truth|inferred
   *
   * @generated from field: string provenance = 6;
   */ _define_property(this, "provenance", ""), /**
   * 0.0 - 1.0
   *
   * @generated from field: double confidence = 7;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 8;
   */ _define_property(this, "effectiveDate", void 0), /**
   * SAM.gov|USAspending|user:<id>|...
   *
   * @generated from field: string source = 9;
   */ _define_property(this, "source", ""), /**
   * none|user_confirmed|superseded
   *
   * @generated from field: string override_status = 10;
   */ _define_property(this, "overrideStatus", ""), /**
   * edge id that superseded this one
   *
   * @generated from field: string overridden_by = 11;
   */ _define_property(this, "overriddenBy", ""), /**
   * @generated from field: string attributes_json = 12;
   */ _define_property(this, "attributesJson", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 15;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EntityEdge, "runtime", proto3);
_define_property(EntityEdge, "typeName", "mono.datagateway.v1.EntityEdge");
_define_property(EntityEdge, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "from_node",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "to_node",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "edge_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "override_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "overridden_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "attributes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.EntityResolutionLogEntry
 */ export class EntityResolutionLogEntry extends Message {
    static fromBinary(bytes, options) {
        return new EntityResolutionLogEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EntityResolutionLogEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EntityResolutionLogEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EntityResolutionLogEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * merge|split|override|pin
   *
   * @generated from field: string action = 3;
   */ _define_property(this, "action", ""), /**
   * @generated from field: string primary_node_id = 4;
   */ _define_property(this, "primaryNodeId", ""), /**
   * @generated from field: string secondary_node_id = 5;
   */ _define_property(this, "secondaryNodeId", ""), /**
   * @generated from field: string edge_id = 6;
   */ _define_property(this, "edgeId", ""), /**
   * @generated from field: string rationale = 7;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string payload_json = 8;
   */ _define_property(this, "payloadJson", ""), /**
   * @generated from field: string actor_user_id = 9;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EntityResolutionLogEntry, "runtime", proto3);
_define_property(EntityResolutionLogEntry, "typeName", "mono.datagateway.v1.EntityResolutionLogEntry");
_define_property(EntityResolutionLogEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "primary_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "secondary_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "edge_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "payload_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * --- Nodes ---
 * Upsert: empty node.id creates; otherwise updates the existing row.
 *
 * @generated from message mono.datagateway.v1.UpsertEntityNodeRequest
 */ export class UpsertEntityNodeRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertEntityNodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertEntityNodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertEntityNodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertEntityNodeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EntityNode node = 1;
   */ _define_property(this, "node", void 0), /**
   * Browser identity writes attach a canonical registry record. Source ingestion
   * retains the existing observation upsert semantics when false.
   *
   * @generated from field: bool canonical_attachment = 2;
   */ _define_property(this, "canonicalAttachment", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertEntityNodeRequest, "runtime", proto3);
_define_property(UpsertEntityNodeRequest, "typeName", "mono.datagateway.v1.UpsertEntityNodeRequest");
_define_property(UpsertEntityNodeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node",
            kind: "message",
            T: EntityNode
        },
        {
            no: 2,
            name: "canonical_attachment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertEntityNodeResponse
 */ export class UpsertEntityNodeResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertEntityNodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertEntityNodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertEntityNodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertEntityNodeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EntityNode node = 1;
   */ _define_property(this, "node", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertEntityNodeResponse, "runtime", proto3);
_define_property(UpsertEntityNodeResponse, "typeName", "mono.datagateway.v1.UpsertEntityNodeResponse");
_define_property(UpsertEntityNodeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node",
            kind: "message",
            T: EntityNode
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetEntityNodeRequest
 */ export class GetEntityNodeRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetEntityNodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEntityNodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEntityNodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEntityNodeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetEntityNodeRequest, "runtime", proto3);
_define_property(GetEntityNodeRequest, "typeName", "mono.datagateway.v1.GetEntityNodeRequest");
_define_property(GetEntityNodeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetEntityNodeResponse
 */ export class GetEntityNodeResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetEntityNodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEntityNodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEntityNodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEntityNodeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EntityNode node = 1;
   */ _define_property(this, "node", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetEntityNodeResponse, "runtime", proto3);
_define_property(GetEntityNodeResponse, "typeName", "mono.datagateway.v1.GetEntityNodeResponse");
_define_property(GetEntityNodeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node",
            kind: "message",
            T: EntityNode
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListEntityNodesRequest
 */ export class ListEntityNodesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListEntityNodesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEntityNodesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEntityNodesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEntityNodesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Optional filter; empty returns all node types.
   *
   * @generated from field: string node_type = 2;
   */ _define_property(this, "nodeType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEntityNodesRequest, "runtime", proto3);
_define_property(ListEntityNodesRequest, "typeName", "mono.datagateway.v1.ListEntityNodesRequest");
_define_property(ListEntityNodesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "node_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListEntityNodesResponse
 */ export class ListEntityNodesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListEntityNodesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEntityNodesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEntityNodesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEntityNodesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.EntityNode nodes = 1;
   */ _define_property(this, "nodes", []), /**
   * @generated from field: repeated mono.datagateway.v1.GraphSourceStatus source_statuses = 2;
   */ _define_property(this, "sourceStatuses", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEntityNodesResponse, "runtime", proto3);
_define_property(ListEntityNodesResponse, "typeName", "mono.datagateway.v1.ListEntityNodesResponse");
_define_property(ListEntityNodesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "nodes",
            kind: "message",
            T: EntityNode,
            repeated: true
        },
        {
            no: 2,
            name: "source_statuses",
            kind: "message",
            T: GraphSourceStatus,
            repeated: true
        }
    ]));
/**
 * A bounded persisted source check, not a claim of universal provider coverage.
 * Public cache timestamps never stand in for a fact's effective/reviewed date.
 *
 * @generated from message mono.datagateway.v1.GraphSourceStatus
 */ export class GraphSourceStatus extends Message {
    static fromBinary(bytes, options) {
        return new GraphSourceStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GraphSourceStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GraphSourceStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GraphSourceStatus, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string source = 1;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string scope = 2;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string coverage = 3;
   */ _define_property(this, "coverage", ""), /**
   * @generated from field: string sync_status = 4;
   */ _define_property(this, "syncStatus", ""), /**
   * @generated from field: string failure_code = 5;
   */ _define_property(this, "failureCode", ""), /**
   * @generated from field: google.protobuf.Timestamp last_successful_at = 6;
   */ _define_property(this, "lastSuccessfulAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp evidence_as_of = 7;
   */ _define_property(this, "evidenceAsOf", void 0), /**
   * @generated from field: int64 retained_observations = 8;
   */ _define_property(this, "retainedObservations", protoInt64.zero), /**
   * @generated from field: int64 explicit_retractions = 9;
   */ _define_property(this, "explicitRetractions", protoInt64.zero), /**
   * @generated from field: bool successful_empty = 10;
   */ _define_property(this, "successfulEmpty", false), /**
   * @generated from field: google.protobuf.Timestamp last_attempted_at = 11;
   */ _define_property(this, "lastAttemptedAt", void 0), /**
   * @generated from field: optional int64 result_count = 12;
   */ _define_property(this, "resultCount", void 0), /**
   * @generated from field: bool truncated = 13;
   */ _define_property(this, "truncated", false), /**
   * @generated from field: string freshness = 14;
   */ _define_property(this, "freshness", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GraphSourceStatus, "runtime", proto3);
_define_property(GraphSourceStatus, "typeName", "mono.datagateway.v1.GraphSourceStatus");
_define_property(GraphSourceStatus, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "coverage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "sync_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "failure_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "last_successful_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "evidence_as_of",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "retained_observations",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 9,
            name: "explicit_retractions",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 10,
            name: "successful_empty",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "last_attempted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "result_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ ,
            opt: true
        },
        {
            no: 13,
            name: "truncated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "freshness",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * --- Edges ---
 *
 * @generated from message mono.datagateway.v1.UpsertEntityEdgeRequest
 */ export class UpsertEntityEdgeRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertEntityEdgeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertEntityEdgeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertEntityEdgeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertEntityEdgeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EntityEdge edge = 1;
   */ _define_property(this, "edge", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertEntityEdgeRequest, "runtime", proto3);
_define_property(UpsertEntityEdgeRequest, "typeName", "mono.datagateway.v1.UpsertEntityEdgeRequest");
_define_property(UpsertEntityEdgeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "edge",
            kind: "message",
            T: EntityEdge
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertEntityEdgeResponse
 */ export class UpsertEntityEdgeResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertEntityEdgeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertEntityEdgeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertEntityEdgeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertEntityEdgeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EntityEdge edge = 1;
   */ _define_property(this, "edge", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertEntityEdgeResponse, "runtime", proto3);
_define_property(UpsertEntityEdgeResponse, "typeName", "mono.datagateway.v1.UpsertEntityEdgeResponse");
_define_property(UpsertEntityEdgeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "edge",
            kind: "message",
            T: EntityEdge
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListEntityEdgesRequest
 */ export class ListEntityEdgesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListEntityEdgesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEntityEdgesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEntityEdgesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEntityEdgesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Optional filters; empty values are ignored. from_node OR to_node matches
   * either endpoint when only one is set.
   *
   * @generated from field: string from_node = 2;
   */ _define_property(this, "fromNode", ""), /**
   * @generated from field: string to_node = 3;
   */ _define_property(this, "toNode", ""), /**
   * @generated from field: string edge_type = 4;
   */ _define_property(this, "edgeType", ""), /**
   * When true, superseded edges are included (the UI wants them to show the
   * resolved-conflict trail); default false returns live edges only.
   *
   * @generated from field: bool include_superseded = 5;
   */ _define_property(this, "includeSuperseded", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEntityEdgesRequest, "runtime", proto3);
_define_property(ListEntityEdgesRequest, "typeName", "mono.datagateway.v1.ListEntityEdgesRequest");
_define_property(ListEntityEdgesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "from_node",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "to_node",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "edge_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "include_superseded",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListEntityEdgesResponse
 */ export class ListEntityEdgesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListEntityEdgesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEntityEdgesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEntityEdgesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEntityEdgesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.EntityEdge edges = 1;
   */ _define_property(this, "edges", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEntityEdgesResponse, "runtime", proto3);
_define_property(ListEntityEdgesResponse, "typeName", "mono.datagateway.v1.ListEntityEdgesResponse");
_define_property(ListEntityEdgesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "edges",
            kind: "message",
            T: EntityEdge,
            repeated: true
        }
    ]));
/**
 * --- Walk ---
 *
 * @generated from message mono.datagateway.v1.WalkFromNodeRequest
 */ export class WalkFromNodeRequest extends Message {
    static fromBinary(bytes, options) {
        return new WalkFromNodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WalkFromNodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WalkFromNodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WalkFromNodeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string node_id = 2;
   */ _define_property(this, "nodeId", ""), /**
   * Follow only this edge_type (e.g. "parent" for the family tree, "org_parent"
   * for the org chart). Empty walks every edge type.
   *
   * @generated from field: string edge_type = 3;
   */ _define_property(this, "edgeType", ""), /**
   * 0 = unlimited (bounded by a server cap). Bounds the subgraph size.
   *
   * @generated from field: int32 max_depth = 4;
   */ _define_property(this, "maxDepth", 0), /**
   * REG-58: root the walk at a registry row instead of a node id (resolved through
   * entity_nodes.registry_id).
   *
   * @generated from field: string root_registry_kind = 5;
   */ _define_property(this, "rootRegistryKind", ""), /**
   * @generated from field: string root_registry_id = 6;
   */ _define_property(this, "rootRegistryId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WalkFromNodeRequest, "runtime", proto3);
_define_property(WalkFromNodeRequest, "typeName", "mono.datagateway.v1.WalkFromNodeRequest");
_define_property(WalkFromNodeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "edge_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "max_depth",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "root_registry_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "root_registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WalkFromNodeResponse
 */ export class WalkFromNodeResponse extends Message {
    static fromBinary(bytes, options) {
        return new WalkFromNodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WalkFromNodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WalkFromNodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WalkFromNodeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.EntityNode nodes = 1;
   */ _define_property(this, "nodes", []), /**
   * @generated from field: repeated mono.datagateway.v1.EntityEdge edges = 2;
   */ _define_property(this, "edges", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WalkFromNodeResponse, "runtime", proto3);
_define_property(WalkFromNodeResponse, "typeName", "mono.datagateway.v1.WalkFromNodeResponse");
_define_property(WalkFromNodeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "nodes",
            kind: "message",
            T: EntityNode,
            repeated: true
        },
        {
            no: 2,
            name: "edges",
            kind: "message",
            T: EntityEdge,
            repeated: true
        }
    ]));
/**
 * --- Override / Merge ---
 *
 * @generated from message mono.datagateway.v1.OverrideEdgeRequest
 */ export class OverrideEdgeRequest extends Message {
    static fromBinary(bytes, options) {
        return new OverrideEdgeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OverrideEdgeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OverrideEdgeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OverrideEdgeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * the edge to pin as user_confirmed
   *
   * @generated from field: string edge_id = 2;
   */ _define_property(this, "edgeId", ""), /**
   * required — surfaced in audit + log
   *
   * @generated from field: string rationale = 3;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string actor_user_id = 4;
   */ _define_property(this, "actorUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OverrideEdgeRequest, "runtime", proto3);
_define_property(OverrideEdgeRequest, "typeName", "mono.datagateway.v1.OverrideEdgeRequest");
_define_property(OverrideEdgeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "edge_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OverrideEdgeResponse
 */ export class OverrideEdgeResponse extends Message {
    static fromBinary(bytes, options) {
        return new OverrideEdgeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OverrideEdgeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OverrideEdgeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OverrideEdgeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EntityEdge edge = 1;
   */ _define_property(this, "edge", void 0), /**
   * The competing edges marked superseded by this override.
   *
   * @generated from field: repeated string superseded_edge_ids = 2;
   */ _define_property(this, "supersededEdgeIds", []), /**
   * @generated from field: mono.datagateway.v1.EntityResolutionLogEntry log_entry = 3;
   */ _define_property(this, "logEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OverrideEdgeResponse, "runtime", proto3);
_define_property(OverrideEdgeResponse, "typeName", "mono.datagateway.v1.OverrideEdgeResponse");
_define_property(OverrideEdgeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "edge",
            kind: "message",
            T: EntityEdge
        },
        {
            no: 2,
            name: "superseded_edge_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "log_entry",
            kind: "message",
            T: EntityResolutionLogEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MergeEntitiesRequest
 */ export class MergeEntitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new MergeEntitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergeEntitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergeEntitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergeEntitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * survives
   *
   * @generated from field: string primary_node_id = 2;
   */ _define_property(this, "primaryNodeId", ""), /**
   * folded into primary + soft-deleted
   *
   * @generated from field: string secondary_node_id = 3;
   */ _define_property(this, "secondaryNodeId", ""), /**
   * @generated from field: string rationale = 4;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string actor_user_id = 5;
   */ _define_property(this, "actorUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergeEntitiesRequest, "runtime", proto3);
_define_property(MergeEntitiesRequest, "typeName", "mono.datagateway.v1.MergeEntitiesRequest");
_define_property(MergeEntitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "primary_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "secondary_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MergeEntitiesResponse
 */ export class MergeEntitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new MergeEntitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergeEntitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergeEntitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergeEntitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EntityNode primary_node = 1;
   */ _define_property(this, "primaryNode", void 0), /**
   * @generated from field: int32 edges_repointed = 2;
   */ _define_property(this, "edgesRepointed", 0), /**
   * @generated from field: mono.datagateway.v1.EntityResolutionLogEntry log_entry = 3;
   */ _define_property(this, "logEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergeEntitiesResponse, "runtime", proto3);
_define_property(MergeEntitiesResponse, "typeName", "mono.datagateway.v1.MergeEntitiesResponse");
_define_property(MergeEntitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "primary_node",
            kind: "message",
            T: EntityNode
        },
        {
            no: 2,
            name: "edges_repointed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "log_entry",
            kind: "message",
            T: EntityResolutionLogEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnmergeEntitiesRequest
 */ export class UnmergeEntitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnmergeEntitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnmergeEntitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnmergeEntitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnmergeEntitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * the merge log entry to reverse
   *
   * @generated from field: string resolution_log_id = 2;
   */ _define_property(this, "resolutionLogId", ""), /**
   * required — surfaced in audit + log
   *
   * @generated from field: string rationale = 3;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string actor_user_id = 4;
   */ _define_property(this, "actorUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnmergeEntitiesRequest, "runtime", proto3);
_define_property(UnmergeEntitiesRequest, "typeName", "mono.datagateway.v1.UnmergeEntitiesRequest");
_define_property(UnmergeEntitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "resolution_log_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnmergeEntitiesResponse
 */ export class UnmergeEntitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnmergeEntitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnmergeEntitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnmergeEntitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnmergeEntitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * restored
   *
   * @generated from field: mono.datagateway.v1.EntityNode secondary_node = 1;
   */ _define_property(this, "secondaryNode", void 0), /**
   * @generated from field: int32 edges_restored = 2;
   */ _define_property(this, "edgesRestored", 0), /**
   * @generated from field: mono.datagateway.v1.EntityResolutionLogEntry log_entry = 3;
   */ _define_property(this, "logEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnmergeEntitiesResponse, "runtime", proto3);
_define_property(UnmergeEntitiesResponse, "typeName", "mono.datagateway.v1.UnmergeEntitiesResponse");
_define_property(UnmergeEntitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "secondary_node",
            kind: "message",
            T: EntityNode
        },
        {
            no: 2,
            name: "edges_restored",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "log_entry",
            kind: "message",
            T: EntityResolutionLogEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListResolutionLogRequest
 */ export class ListResolutionLogRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListResolutionLogRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListResolutionLogRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListResolutionLogRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListResolutionLogRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Optional: filter to entries touching this node (primary or secondary).
   *
   * @generated from field: string node_id = 2;
   */ _define_property(this, "nodeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListResolutionLogRequest, "runtime", proto3);
_define_property(ListResolutionLogRequest, "typeName", "mono.datagateway.v1.ListResolutionLogRequest");
_define_property(ListResolutionLogRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListResolutionLogResponse
 */ export class ListResolutionLogResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListResolutionLogResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListResolutionLogResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListResolutionLogResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListResolutionLogResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.EntityResolutionLogEntry entries = 1;
   */ _define_property(this, "entries", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListResolutionLogResponse, "runtime", proto3);
_define_property(ListResolutionLogResponse, "typeName", "mono.datagateway.v1.ListResolutionLogResponse");
_define_property(ListResolutionLogResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entries",
            kind: "message",
            T: EntityResolutionLogEntry,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteEntityNodeRequest
 */ export class DeleteEntityNodeRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteEntityNodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteEntityNodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteEntityNodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteEntityNodeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteEntityNodeRequest, "runtime", proto3);
_define_property(DeleteEntityNodeRequest, "typeName", "mono.datagateway.v1.DeleteEntityNodeRequest");
_define_property(DeleteEntityNodeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteEntityNodeResponse
 */ export class DeleteEntityNodeResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteEntityNodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteEntityNodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteEntityNodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteEntityNodeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Number of incident edges soft-deleted alongside the node.
   *
   * @generated from field: int32 edges_deleted = 1;
   */ _define_property(this, "edgesDeleted", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteEntityNodeResponse, "runtime", proto3);
_define_property(DeleteEntityNodeResponse, "typeName", "mono.datagateway.v1.DeleteEntityNodeResponse");
_define_property(DeleteEntityNodeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "edges_deleted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteEntityEdgeRequest
 */ export class DeleteEntityEdgeRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteEntityEdgeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteEntityEdgeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteEntityEdgeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteEntityEdgeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteEntityEdgeRequest, "runtime", proto3);
_define_property(DeleteEntityEdgeRequest, "typeName", "mono.datagateway.v1.DeleteEntityEdgeRequest");
_define_property(DeleteEntityEdgeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteEntityEdgeResponse
 */ export class DeleteEntityEdgeResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteEntityEdgeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteEntityEdgeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteEntityEdgeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteEntityEdgeResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteEntityEdgeResponse, "runtime", proto3);
_define_property(DeleteEntityEdgeResponse, "typeName", "mono.datagateway.v1.DeleteEntityEdgeResponse");
_define_property(DeleteEntityEdgeResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.SyncWatermark
 */ export class SyncWatermark extends Message {
    static fromBinary(bytes, options) {
        return new SyncWatermark().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncWatermark().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncWatermark().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncWatermark, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * USAspending | SAM.gov
   *
   * @generated from field: string source = 2;
   */ _define_property(this, "source", ""), /**
   * awarding toptier agency
   *
   * @generated from field: string agency = 3;
   */ _define_property(this, "agency", ""), /**
   * YYYY-MM-DD high-water mark (may be empty)
   *
   * @generated from field: string last_synced_date = 4;
   */ _define_property(this, "lastSyncedDate", ""), /**
   * @generated from field: google.protobuf.Timestamp last_run_at = 5;
   */ _define_property(this, "lastRunAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncWatermark, "runtime", proto3);
_define_property(SyncWatermark, "typeName", "mono.datagateway.v1.SyncWatermark");
_define_property(SyncWatermark, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "last_synced_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "last_run_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertSyncWatermarkRequest
 */ export class UpsertSyncWatermarkRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertSyncWatermarkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertSyncWatermarkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertSyncWatermarkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertSyncWatermarkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * "USAspending" (agency scope), or DAT-01's contract scopes
   * "USAspending:contracts:COMPANY" / "USAspending:contracts:VEHICLE".
   *
   * @generated from field: string source = 2;
   */ _define_property(this, "source", ""), /**
   * Legacy name: the agency name for source "USAspending", and the scope
   * reference for every other source (the recipient UEI for
   * USAspending:contracts:COMPANY, the IDV PIID for ...:VEHICLE).
   *
   * @generated from field: string agency = 3;
   */ _define_property(this, "agency", ""), /**
   * YYYY-MM-DD
   *
   * @generated from field: string last_synced_date = 4;
   */ _define_property(this, "lastSyncedDate", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertSyncWatermarkRequest, "runtime", proto3);
_define_property(UpsertSyncWatermarkRequest, "typeName", "mono.datagateway.v1.UpsertSyncWatermarkRequest");
_define_property(UpsertSyncWatermarkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "last_synced_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertSyncWatermarkResponse
 */ export class UpsertSyncWatermarkResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertSyncWatermarkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertSyncWatermarkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertSyncWatermarkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertSyncWatermarkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SyncWatermark watermark = 1;
   */ _define_property(this, "watermark", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertSyncWatermarkResponse, "runtime", proto3);
_define_property(UpsertSyncWatermarkResponse, "typeName", "mono.datagateway.v1.UpsertSyncWatermarkResponse");
_define_property(UpsertSyncWatermarkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "watermark",
            kind: "message",
            T: SyncWatermark
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSyncWatermarksRequest
 */ export class ListSyncWatermarksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSyncWatermarksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSyncWatermarksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSyncWatermarksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSyncWatermarksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * empty => all tenants (scheduler iterates everything)
   *
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSyncWatermarksRequest, "runtime", proto3);
_define_property(ListSyncWatermarksRequest, "typeName", "mono.datagateway.v1.ListSyncWatermarksRequest");
_define_property(ListSyncWatermarksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSyncWatermarksResponse
 */ export class ListSyncWatermarksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSyncWatermarksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSyncWatermarksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSyncWatermarksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSyncWatermarksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.SyncWatermark watermarks = 1;
   */ _define_property(this, "watermarks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSyncWatermarksResponse, "runtime", proto3);
_define_property(ListSyncWatermarksResponse, "typeName", "mono.datagateway.v1.ListSyncWatermarksResponse");
_define_property(ListSyncWatermarksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "watermarks",
            kind: "message",
            T: SyncWatermark,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetGovOrgChartRequest
 */ export class GetGovOrgChartRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetGovOrgChartRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGovOrgChartRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGovOrgChartRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGovOrgChartRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * a gov_org node (any level); mapped to its registry_id (REG-58)
   *
   * @generated from field: string root_node_id = 2;
   */ _define_property(this, "rootNodeId", ""), /**
   * 0 => server cap
   *
   * @generated from field: int32 max_depth = 3;
   */ _define_property(this, "maxDepth", 0), /**
   * REG-58: the government organization (registry id) to root the chart at. The chart
   * reads the registry first (parent_id, open employments); public edges are added
   * beside it, labelled by source.
   *
   * @generated from field: string root_registry_id = 4;
   */ _define_property(this, "rootRegistryId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGovOrgChartRequest, "runtime", proto3);
_define_property(GetGovOrgChartRequest, "typeName", "mono.datagateway.v1.GetGovOrgChartRequest");
_define_property(GetGovOrgChartRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "root_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "max_depth",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "root_registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * GovOrgChartEntry is one gov_org office in the chart. parent_node_id is the
 * org_parent edge target (empty at the root of the returned subtree).
 *
 * @generated from message mono.datagateway.v1.GovOrgChartEntry
 */ export class GovOrgChartEntry extends Message {
    static fromBinary(bytes, options) {
        return new GovOrgChartEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovOrgChartEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovOrgChartEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovOrgChartEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EntityNode node = 1;
   */ _define_property(this, "node", void 0), /**
   * agency|bureau|program_office|contracting_office (from attributes)
   *
   * @generated from field: string org_level = 2;
   */ _define_property(this, "orgLevel", ""), /**
   * @generated from field: string parent_node_id = 3;
   */ _define_property(this, "parentNodeId", ""), /**
   * REG-58 registry-first fields.
   *
   * "" for a public org the registry lacks
   *
   * @generated from field: string registry_id = 4;
   */ _define_property(this, "registryId", ""), /**
   * "registry" or the public edge's source
   *
   * @generated from field: string source = 5;
   */ _define_property(this, "source", ""), /**
   * false = a public addition shown beside the registry
   *
   * @generated from field: bool registry = 6;
   */ _define_property(this, "registry", false), /**
   * @generated from field: string parent_registry_id = 7;
   */ _define_property(this, "parentRegistryId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovOrgChartEntry, "runtime", proto3);
_define_property(GovOrgChartEntry, "typeName", "mono.datagateway.v1.GovOrgChartEntry");
_define_property(GovOrgChartEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node",
            kind: "message",
            T: EntityNode
        },
        {
            no: 2,
            name: "org_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "parent_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "registry",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "parent_registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * GovOrgChartPerson is a person attached to an office by a role edge; role is
 * the edge_type. Effective date + source are carried per the §7 rule.
 *
 * @generated from message mono.datagateway.v1.GovOrgChartPerson
 */ export class GovOrgChartPerson extends Message {
    static fromBinary(bytes, options) {
        return new GovOrgChartPerson().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovOrgChartPerson().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovOrgChartPerson().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovOrgChartPerson, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EntityNode person = 1;
   */ _define_property(this, "person", void 0), /**
   * @generated from field: string gov_org_node_id = 2;
   */ _define_property(this, "govOrgNodeId", ""), /**
   * @generated from field: string role = 3;
   */ _define_property(this, "role", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 4;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: string source = 5;
   */ _define_property(this, "source", ""), /**
   * @generated from field: double confidence = 6;
   */ _define_property(this, "confidence", 0), /**
   * REG-58: registry people (open employments) and public person records.
   *
   * "" for a public record
   *
   * @generated from field: string contact_id = 7;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string employment_id = 8;
   */ _define_property(this, "employmentId", ""), /**
   * @generated from field: string seat_title = 9;
   */ _define_property(this, "seatTitle", ""), /**
   * a person node keyed only by a public key (e.g. a notice POC)
   *
   * @generated from field: bool public_record = 10;
   */ _define_property(this, "publicRecord", false), /**
   * @generated from field: string public_key = 11;
   */ _define_property(this, "publicKey", ""), /**
   * @generated from field: string display_name = 12;
   */ _define_property(this, "displayName", ""), /**
   * seat title, else an IMPORT employment's evidence role
   *
   * @generated from field: string role_label = 13;
   */ _define_property(this, "roleLabel", ""), /**
   * @generated from field: string gov_org_registry_id = 14;
   */ _define_property(this, "govOrgRegistryId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovOrgChartPerson, "runtime", proto3);
_define_property(GovOrgChartPerson, "typeName", "mono.datagateway.v1.GovOrgChartPerson");
_define_property(GovOrgChartPerson, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "person",
            kind: "message",
            T: EntityNode
        },
        {
            no: 2,
            name: "gov_org_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "employment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "seat_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "public_record",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "public_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "role_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "gov_org_registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetGovOrgChartResponse
 */ export class GetGovOrgChartResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetGovOrgChartResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGovOrgChartResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGovOrgChartResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGovOrgChartResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.GovOrgChartEntry orgs = 1;
   */ _define_property(this, "orgs", []), /**
   * @generated from field: repeated mono.datagateway.v1.GovOrgChartPerson people = 2;
   */ _define_property(this, "people", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGovOrgChartResponse, "runtime", proto3);
_define_property(GetGovOrgChartResponse, "typeName", "mono.datagateway.v1.GetGovOrgChartResponse");
_define_property(GetGovOrgChartResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "orgs",
            kind: "message",
            T: GovOrgChartEntry,
            repeated: true
        },
        {
            no: 2,
            name: "people",
            kind: "message",
            T: GovOrgChartPerson,
            repeated: true
        }
    ]));
/**
 * Contains only bounded metadata, never provider errors, credentials or request text.
 *
 * @generated from message mono.datagateway.v1.RecordGraphProviderOutcomeRequest
 */ export class RecordGraphProviderOutcomeRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordGraphProviderOutcomeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordGraphProviderOutcomeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordGraphProviderOutcomeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordGraphProviderOutcomeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string source = 2;
   */ _define_property(this, "source", ""), /**
   * SHA-256 of the bounded provider query
   *
   * @generated from field: string query_key = 3;
   */ _define_property(this, "queryKey", ""), /**
   * opportunities | awards | vehicles
   *
   * @generated from field: string query_kind = 4;
   */ _define_property(this, "queryKind", ""), /**
   * complete | partial | failed
   *
   * @generated from field: string sync_status = 5;
   */ _define_property(this, "syncStatus", ""), /**
   * allowlisted, sanitized classification
   *
   * @generated from field: string failure_code = 6;
   */ _define_property(this, "failureCode", ""), /**
   * absent on failure
   *
   * @generated from field: optional int64 result_count = 7;
   */ _define_property(this, "resultCount", void 0), /**
   * @generated from field: bool truncated = 8;
   */ _define_property(this, "truncated", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordGraphProviderOutcomeRequest, "runtime", proto3);
_define_property(RecordGraphProviderOutcomeRequest, "typeName", "mono.datagateway.v1.RecordGraphProviderOutcomeRequest");
_define_property(RecordGraphProviderOutcomeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "query_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "query_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "sync_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "failure_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "result_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ ,
            opt: true
        },
        {
            no: 8,
            name: "truncated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordGraphProviderOutcomeResponse
 */ export class RecordGraphProviderOutcomeResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordGraphProviderOutcomeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordGraphProviderOutcomeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordGraphProviderOutcomeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordGraphProviderOutcomeResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordGraphProviderOutcomeResponse, "runtime", proto3);
_define_property(RecordGraphProviderOutcomeResponse, "typeName", "mono.datagateway.v1.RecordGraphProviderOutcomeResponse");
_define_property(RecordGraphProviderOutcomeResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.PursuitGraphRegistryRef
 */ export class PursuitGraphRegistryRef extends Message {
    static fromBinary(bytes, options) {
        return new PursuitGraphRegistryRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitGraphRegistryRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitGraphRegistryRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitGraphRegistryRef, a, b);
    }
    constructor(data){
        super(), /**
   * CONTACT | COMPANY | GOVERNMENT_ORG | VEHICLE
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * registry id (survivor after merge chains)
   *
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitGraphRegistryRef, "runtime", proto3);
_define_property(PursuitGraphRegistryRef, "typeName", "mono.datagateway.v1.PursuitGraphRegistryRef");
_define_property(PursuitGraphRegistryRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPursuitGraphRequest
 */ export class GetPursuitGraphRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitGraphRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitGraphRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitGraphRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitGraphRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * 0 = seeds only, 1 or 2; values > 2 are clamped to 2
   *
   * @generated from field: int32 hops = 3;
   */ _define_property(this, "hops", 0), /**
   * @generated from field: bool include_superseded = 4;
   */ _define_property(this, "includeSuperseded", false), /**
   * claim ABOUT targets the viewer may see (zou)
   *
   * @generated from field: repeated mono.datagateway.v1.PursuitGraphRegistryRef extra_seeds = 5;
   */ _define_property(this, "extraSeeds", []), /**
   * 0 -> 150; clamped to 300
   *
   * @generated from field: int32 max_nodes = 6;
   */ _define_property(this, "maxNodes", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitGraphRequest, "runtime", proto3);
_define_property(GetPursuitGraphRequest, "typeName", "mono.datagateway.v1.GetPursuitGraphRequest");
_define_property(GetPursuitGraphRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "hops",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_superseded",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "extra_seeds",
            kind: "message",
            T: PursuitGraphRegistryRef,
            repeated: true
        },
        {
            no: 6,
            name: "max_nodes",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PursuitGraphSeed
 */ export class PursuitGraphSeed extends Message {
    static fromBinary(bytes, options) {
        return new PursuitGraphSeed().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitGraphSeed().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitGraphSeed().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitGraphSeed, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PursuitGraphRegistryRef ref = 1;
   */ _define_property(this, "ref", void 0), /**
   * customer | contracting | incumbent | competitor | teaming | stakeholder | attendee |
   * vehicle | event_attendee | event_host | claim_subject
   *
   * @generated from field: repeated string seed_roles = 2;
   */ _define_property(this, "seedRoles", []), /**
   * "" when the projector has not drawn it yet
   *
   * @generated from field: string node_id = 3;
   */ _define_property(this, "nodeId", ""), /**
   * registry name, read at request time
   *
   * @generated from field: string label = 4;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitGraphSeed, "runtime", proto3);
_define_property(PursuitGraphSeed, "typeName", "mono.datagateway.v1.PursuitGraphSeed");
_define_property(PursuitGraphSeed, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ref",
            kind: "message",
            T: PursuitGraphRegistryRef
        },
        {
            no: 2,
            name: "seed_roles",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPursuitGraphResponse
 */ export class GetPursuitGraphResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitGraphResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitGraphResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitGraphResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitGraphResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.EntityNode nodes = 1;
   */ _define_property(this, "nodes", []), /**
   * @generated from field: repeated mono.datagateway.v1.EntityEdge edges = 2;
   */ _define_property(this, "edges", []), /**
   * @generated from field: repeated mono.datagateway.v1.PursuitGraphSeed seeds = 3;
   */ _define_property(this, "seeds", []), /**
   * max_nodes reached; seeds are always kept
   *
   * @generated from field: bool truncated = 4;
   */ _define_property(this, "truncated", false), /**
   * projector watermark (RFC3339), "" when never projected
   *
   * @generated from field: string projected_through = 5;
   */ _define_property(this, "projectedThrough", ""), /**
   * @generated from field: repeated mono.datagateway.v1.GraphSourceStatus source_statuses = 6;
   */ _define_property(this, "sourceStatuses", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitGraphResponse, "runtime", proto3);
_define_property(GetPursuitGraphResponse, "typeName", "mono.datagateway.v1.GetPursuitGraphResponse");
_define_property(GetPursuitGraphResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "nodes",
            kind: "message",
            T: EntityNode,
            repeated: true
        },
        {
            no: 2,
            name: "edges",
            kind: "message",
            T: EntityEdge,
            repeated: true
        },
        {
            no: 3,
            name: "seeds",
            kind: "message",
            T: PursuitGraphSeed,
            repeated: true
        },
        {
            no: 4,
            name: "truncated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "projected_through",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_statuses",
            kind: "message",
            T: GraphSourceStatus,
            repeated: true
        }
    ]));
